import { Box } from '@mui/material';
import { dashboardStyle } from './style';

export const HelpCenter = () => {
  const { helpCenterStyle } = dashboardStyle;

  return (
    <Box className='help-center' sx={helpCenterStyle}>
      <iframe title='help-center' src='https://psylaris.helpkit.so/' />
    </Box>
  );
};
